import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

export default function PartnerLeads() {
  const [negs, setNegs] = useState([]);
  const [reqs, setReqs] = useState([]);
  const [allReqs, setAllReqs] = useState([]);
  useEffect(() => {
    api.get("/negotiations/mine").then(({ data }) => setNegs(data));
    api.get("/booking-requests").then(({ data }) => setReqs(data));
    // "All open" fallback — every open request across every city
    api.get("/booking-requests?scope=all").then(({ data }) => setAllReqs(data)).catch((e) => console.debug("fetch failed:", e?.message));
  }, []);

  const renderReqs = (list) =>
    list.length === 0 ? (
      <div className="hw-card p-10 text-center text-slate-600" data-testid="leads-empty">No open requests to show.</div>
    ) : list.map((r) => (
      <Link to={`/requests/${r.request_id}`} key={r.request_id} className="hw-card p-5 flex items-center justify-between hover:hw-shadow-pop transition-all hover:-translate-y-0.5 block" data-testid={`lead-req-${r.request_id}`}>
        <div>
          <h3 className="hw-head font-bold text-lg text-slate-900">{r.city}{r.area ? ` · ${r.area}` : ""} · {r.rooms_needed} rooms</h3>
          <div className="text-sm text-slate-500">{r.customer_name} · {r.event_type} · {r.checkin} → {r.checkout}{r.budget_per_room ? ` · Budget ₹${r.budget_per_room}/room` : ""}</div>
        </div>
        <span className="hw-chip border-blue-600 bg-emerald-50 text-emerald-800">Submit bid →</span>
      </Link>
    ));

  return (
    <div className="bg-slate-50 min-h-[calc(100vh-4rem)]">
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-10">
        <div className="hw-label text-blue-700">Inbox</div>
        <h1 className="hw-head text-4xl md:text-5xl font-black text-slate-900 mt-3">Leads</h1>

        <Tabs defaultValue="req" className="mt-8">
          <TabsList className="rounded-sm bg-white border border-slate-200 p-1">
            <TabsTrigger value="req" data-testid="tab-requests" className="rounded-sm data-[state=active]:bg-emerald-600 data-[state=active]:text-slate-900 font-bold">In your city ({reqs.length})</TabsTrigger>
            <TabsTrigger value="all" data-testid="tab-all-requests" className="rounded-sm data-[state=active]:bg-emerald-600 data-[state=active]:text-slate-900 font-bold">All open leads ({allReqs.length})</TabsTrigger>
            <TabsTrigger value="neg" data-testid="tab-negotiations" className="rounded-sm data-[state=active]:bg-emerald-600 data-[state=active]:text-slate-900 font-bold">Negotiations ({negs.length})</TabsTrigger>
          </TabsList>
          <TabsContent value="req" className="mt-5 space-y-3" data-testid="reqs-in-city">
            {renderReqs(reqs)}
          </TabsContent>
          <TabsContent value="all" className="mt-5 space-y-3" data-testid="reqs-all">
            <p className="text-xs text-slate-500">Requests posted anywhere in India — bid on any that fits your hotel.</p>
            {renderReqs(allReqs)}
          </TabsContent>
          <TabsContent value="neg" className="mt-5 space-y-3">
            {negs.length === 0 ? <div className="hw-card p-10 text-center text-slate-600">No negotiations yet.</div> : negs.map((n) => (
              <Link to="/negotiations" key={n.negotiation_id} className="hw-card p-5 flex items-center justify-between hover:hw-shadow-pop transition-all hover:-translate-y-0.5 block" data-testid={`lead-neg-${n.negotiation_id}`}>
                <div>
                  <h3 className="hw-head font-bold text-lg text-slate-900">{n.customer_name}</h3>
                  <div className="text-sm text-slate-500">Offer ₹{n.offer_price} on ₹{n.initial_price} · {n.rooms_needed} rooms</div>
                </div>
                <span className="hw-chip border-emerald-300 bg-emerald-50 text-blue-700 hw-label">{n.status}</span>
              </Link>
            ))}
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
